import React, { useState, useEffect, useRef } from "react";
import ReportCount from "../reports/ReportCount";
import ProductVariantReport from "../product_variants/ProductVariantReport";
import readReportCount from "../../utils/readReportCount";
import FunnelTrackedMetrics from "../reports/FunnelTrackedMetrics";

const ProductReport = (props) => {
  const [showProductVariants, setShowProductVariants] = useState(false);
  const element = props.element;
  const product = props.product;
  const idPrefix = props.reportIdPrefix || "";
  const product_variants = [...(product.product_variants || [])].sort(
    (a, b) => (a.position || 0) - (b.position || 0)
  );

  const calculateSelectionRates = (element) => {
    const conversionsSpan = document.getElementById(
      `${idPrefix}product-report-${product.id}`
    );
    const conversions = readReportCount(conversionsSpan);

    $(
      `.element-selection-report[data-product-id="${product.id}"][data-report-id-prefix="${idPrefix}"]`
    ).each((i, elementSelectionReportDiv) => {
      const selectionsSpan = $(elementSelectionReportDiv).find(
        ".events-report-count"
      )[0];
      const conversionRateElement = $(elementSelectionReportDiv).find(
        ".conversion-rate"
      )[0];
      const conversionBarElement = $(elementSelectionReportDiv).find(
        ".element-selection-report-bar"
      )[0];

      const selections = readReportCount(selectionsSpan);
      let conversionRateValue =
        selections > 0 && conversions > 0
          ? (selections / conversions) * 100
          : 0;

      if (conversionRateValue > 100) {
        conversionRateValue = 100.0;
      }

      $(conversionRateElement).text(conversionRateValue.toFixed(2));

      if (conversionRateValue > 0) {
        $(conversionBarElement)
          .css("width", `${conversionRateValue}%`)
          .attr("aria-valuenow", conversionRateValue)
          .show();
      }
      $(elementSelectionReportDiv).css("order", selections);
    });
  };

  return (
    <React.Fragment>
      <div
        className="row hard-center element-selection-report"
        data-element-id={element.id}
        data-report-id-prefix={idPrefix}
        style={{ width: "100%" }}
      >
        <div
          className="element-selection-report-bar"
          style={{ width: "100%" }}
        ></div>
        <div
          className="row hard-center funnel-breakdown-item-row"
          style={{
            cursor: product_variants.length > 0 ? "pointer" : undefined,
          }}
          onClick={
            product_variants.length > 0
              ? () => {
                  setShowProductVariants(!showProductVariants);
                }
              : undefined
          }
          onKeyDown={
            product_variants.length > 0
              ? (event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    setShowProductVariants(!showProductVariants);
                  }
                }
              : undefined
          }
          role={product_variants.length > 0 ? "button" : undefined}
          tabIndex={product_variants.length > 0 ? 0 : undefined}
          aria-expanded={
            product_variants.length > 0 ? showProductVariants : undefined
          }
        >
          <div className="col-xs-4 funnel-breakdown-question-label">
            <div
              className="text-xl product-report-toggle"
              data-product-id={product.id}
              style={{
                marginBottom: "5px",
                display: "flex",
                alignItems: "center",
              }}
            >
              {product.position != null && (
                <span
                  className="funnel-breakdown-question-position"
                  style={{ flexShrink: 0 }}
                >
                  {product.position}
                </span>
              )}
              <span
                className="ellipsis funnel-breakdown-question-text"
                style={{ minWidth: 0 }}
              >
                {product.position != null ? " - " : ""}
                {props.label}
              </span>
              <span
                className={`glyphicon glyphicon-chevron-${
                  showProductVariants ? "down" : "right"
                } element-selection-report-toggle ml-1`}
                style={{
                  display: product_variants.length > 0 ? "inline" : "none",
                  flexShrink: 0,
                }}
              ></span>
            </div>
          </div>
          <div className="col-xs-8 right">
            <p className="light text-xl" style={{ marginBottom: "10px" }}>
              <strong>
                <ReportCount
                  inline={true}
                  id={`${idPrefix}product-report-${product.id}`}
                  path={`/websites/${props.cta.website_id}/events_reports`}
                  payload={{
                    report_type: "distinct_count",
                    report: {
                      website_id: props.cta.website_id,
                      event_type: "Complete",
                      contactable_type: "Cta",
                      contactable_id: props.cta.id,
                      variant_id: props.step.variant_id,
                      step_id: props.step.id,
                      element_id: element.id,
                      product_id: product.id,
                      product_variant_id: null,
                      range_start: props.range_start,
                      range_end: props.range_end,
                      broadcast_id: null,
                    },
                  }}
                  callback={() => {
                    props.calculationConversionRates();
                  }}
                />
              </strong>{" "}
              selected (<span className="conversion-rate">0.00</span>
              %)
              <FunnelTrackedMetrics
                layout="details"
                idBase={`${idPrefix}product-${product.id}`}
                selectionsId={`${idPrefix}product-report-${product.id}`}
                path={`/websites/${props.cta.website_id}/events_reports`}
                currency={props.currency}
                gateReports={props.gateReports}
                reportingGoals={props.reportingGoals}
                report={{
                  website_id: props.cta.website_id,
                  contactable_type: "Cta",
                  contactable_id: props.cta.id,
                  variant_id: props.step.variant_id,
                  step_id: props.step.id,
                  element_id: element.id,
                  range_start: props.range_start,
                  range_end: props.range_end,
                  field: null,
                  value: null,
                  product_id: product.id,
                  product_variant_id: null,
                  broadcast_id: null,
                }}
              />
            </p>
          </div>
        </div>
        {showProductVariants && (
          <div
            className="row hard-center"
            style={{
              display: "flex",
              width: "100%",
              flexBasis: "100%",
              flexWrap: "wrap",
              flexDirection: "column-reverse",
            }}
          >
            {product_variants.map((product_variant) => {
              return (
                <ProductVariantReport
                  key={`product-variant-report-${product_variant.id}`}
                  id={`product-variant-report-${product_variant.id}`}
                  product={product}
                  product_variant={product_variant}
                  calculateSelectionRates={() => {
                    calculateSelectionRates();
                  }}
                  {...props}
                />
              );
            })}
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default ProductReport;
